module.exports = __webpack_public_path__ + "img/hr-radar.2d8d6a38.png";